<template>
    <div>
        <app-toolbar :toolbar="toolbar"></app-toolbar>
        <v-container fluid>
        <!-- mainTable Start -->
            <v-radio-group
                v-model="boss_filter"
                row
                @change="filterBossCodes()"
            >
                <v-radio
                    label="Boss Codes"
                    value="1"
                ></v-radio>
                <v-radio
                    label="NB Boss Codes"
                    value="0"
                ></v-radio>
            </v-radio-group>


            <v-simple-table class="mainTable" fixed-header height="75vh">
                <thead>
                    <tr>
                        <th v-show="editMode" width="20">
                        </th>
                        <th v-show="editMode" width="20">EDIT</th>
                        <th> BOSS CODE </th>
                        <th> DOC ARRANGEMENT </th>
                        <th> SCHED FOR </th>
                        <th> VISIBLE TO PLANNER </th>
                        <th> ARRANGEMENT </th>
                        <th> NB CODE </th>
                        <th v-show="viewMode"> CREATED </th>
                        <th v-show="viewMode"> UPDATED </th>
                        <th v-show="viewMode"> CREATED BY </th>
                        <th v-show="viewMode"> UPDATED BY </th>
                    </tr>
                </thead>
                <tbody>
                    <tr v-for="(bossCode, i) in BOSS_CODE" :key="i">
                        <td v-show="editMode">
                            <v-checkbox v-model="bossCode.selected" dense></v-checkbox>
                        </td>
                        <td v-show="editMode"> 
                            <v-btn
                                fab
                                x-small
                                @click="toggleUpdateDialog(bossCode)"
                            >
                                <v-icon >mdi-pencil</v-icon> 
                            </v-btn>
                        </td>
                        <td> {{ bossCode.boss_code }} </td>
                        <td> {{ bossCode.doc_arrangement }} </td>
                        <td> {{ bossCode.sched_for }} </td>
                        <td>
                            <v-chip
                                class="ma-2"
                                :color="bossCode.planner_display == '1' ? 'green' : 'red'"
                                text-color="white"
                                x-small
                            >
                            {{ bossCode.planner_display ? 'YES' : 'NO' }} 
                            </v-chip>
                        </td>
                        <td> {{ bossCode.code_arrangement }} </td>
                        <td> 
                            <v-chip
                                class="ma-2"
                                v-if="bossCode.is_nb"
                                :color="bossCode.is_nb == '1' ? 'green' : 'red'"
                                text-color="white"
                                x-small
                            >
                            {{ bossCode.is_nb == '1' ? 'YES' : 'NO' }} 
                            </v-chip>
                        </td>
                        <td v-show="viewMode"> {{ formatDate(bossCode.created_at) }} </td>
                        <td v-show="viewMode"> {{ formatDate(bossCode.updated_at) }} </td>
                        <td v-show="viewMode"> {{ bossCode.created_by }} </td>
                        <td v-show="viewMode"> {{ bossCode.updated_by }} </td>
                    </tr>
                </tbody>
            </v-simple-table>
        <!-- mainTable End -->

            
        </v-container>

        <!-- Dialogs -->
        <!-- dialogStore Start -->
        <v-dialog v-model="dialogStore" max-width="300" persistent>
            <v-form id="Store" ref="Store" @submit.prevent="Store">
                <v-card>
                    <v-card-title> <span class="overline">Create New {{dialogBossTitle}}</span> </v-card-title>
                        <v-card-text>
                            <v-row>
                                <v-col cols="12">
                                    <v-text-field
                                        v-model="nb_bossCode"
                                        v-if="boss_filter == '1'"
                                        @input="uppercaseInput"
                                        outlined 
                                        dense 
                                        label="Boss Code"
                                        name="boss" 
                                        class="required"
                                        :rules="[...rules.required, ...rules.noNBString]"
                                    > </v-text-field>
                                    <v-text-field
                                        v-model="nb_bossCode"
                                        v-else
                                        @input="uppercaseInput"
                                        outlined 
                                        dense 
                                        label="Boss Code"
                                        name="boss" 
                                        class="required"
                                        :rules="rules.required"
                                    > </v-text-field>
                                </v-col>
                                <v-col cols="12">
                                    <v-text-field 
                                        outlined 
                                        dense 
                                        label="Document Arrangement"
                                        name="doc_arrangement" 
                                        class="required"
                                        :rules="rules.required"
                                    > </v-text-field>
                                </v-col>
                                <v-col cols="12">
                                    <v-text-field 
                                        outlined 
                                        dense 
                                        label="Sched For"
                                        name="sched_for" 
                                        class="required"
                                        :rules="rules.required"
                                    > </v-text-field>
                                </v-col>
                                <v-col cols="12">
                                    <v-select 
                                        outlined 
                                        dense 
                                        label="Visible to planner"
                                        name="planner_display" 
                                        :items="displayOPtion"
                                        item-text="text"
                                        item-value="value"
                                        class="required"
                                        :rules="rules.required"
                                    > </v-select>
                                </v-col>
                                <v-col cols="12">
                                    <v-text-field 
                                        outlined 
                                        v-model="code_arrangement"
                                        dense 
                                        label="Arrangement"
                                        name="code_arrangement" 
                                        class="required"
                                        type="number"
                                        :rules="rules.required"
                                    > </v-text-field>
                                </v-col>
                                <v-col cols="12">
                                    <v-autocomplete
                                        outlined 
                                        dense 
                                        label="NB Code"
                                        name="is_nb" 
                                        class="required"
                                        :items="displayOPtion"
                                        item-text="text"
                                        item-value="value"
                                        :rules="rules.required"
                                    > </v-autocomplete>
                                </v-col>
                            </v-row>
                        </v-card-text>
                    <v-card-actions>
                        <v-spacer></v-spacer>
                        <v-btn text type="submit">保存</v-btn>
                        <v-btn text @click="dialogStore = false">キャンセル</v-btn>
                    </v-card-actions>
                </v-card>
            </v-form>
        </v-dialog>
        <!-- dialogStore End -->

        <!-- dialogUpdate Start -->
        <v-dialog v-model="dialogUpdate" max-width="300" persistent>
            <v-form id="Update" ref="Update" @submit.prevent="Update">
                <v-card>
                    <v-card-title> <span class="overline">Edit Boss Code</span> </v-card-title>
                        <v-card-text>
                            <v-row>
                                <v-col cols="12">
                                    <v-text-field 
                                        v-model="tempData.boss_code"
                                        outlined 
                                        dense 
                                        label="Boss Code"
                                        name="boss" 
                                        class="required"
                                        :rules="rules.required"
                                    > </v-text-field>
                                </v-col>
                                <v-col cols="12">
                                    <v-text-field 
                                        v-model="tempData.doc_arrangement"
                                        outlined 
                                        dense 
                                        label="Document Arrangement"
                                        name="doc_name" 
                                        class="required"
                                        :rules="rules.required"
                                    > </v-text-field>
                                </v-col>
                                <v-col cols="12">
                                    <v-text-field 
                                        v-model="tempData.sched_for"
                                        outlined 
                                        dense 
                                        label="Sched For"
                                        name="sched_for" 
                                        class="required"
                                        :rules="rules.required"
                                    > </v-text-field>
                                </v-col>
                                <v-col cols="12">
                                    <v-select 
                                        outlined 
                                        v-model="tempData.planner_display"
                                        dense 
                                        label="Visible to planner"
                                        name="planner_display" 
                                        :items="displayOPtion"
                                        item-text="text"
                                        item-value="value"
                                        class="required"
                                        :rules="rules.required"
                                    > </v-select>
                                </v-col>
                                <v-col cols="12">
                                    <v-text-field 
                                        v-model="tempData.code_arrangement"
                                        outlined 
                                        dense 
                                        label="Arrangement"
                                        name="code_arrangement" 
                                        class="required"
                                        type="number"
                                        :rules="rules.required"
                                    > </v-text-field>
                                </v-col>
                                <v-col cols="12">
                                    <v-select 
                                        outlined 
                                        v-model="tempData.is_nb"
                                        dense 
                                        label="NB CODE"
                                        name="is_nb" 
                                        :items="displayOPtion"
                                        item-text="text"
                                        item-value="value"
                                        class="required"
                                        :rules="rules.required"
                                    > </v-select>
                                </v-col>
                            </v-row>
                        </v-card-text>
                    <v-card-actions>
                        <v-spacer></v-spacer>
                        <v-btn text type="submit">保存</v-btn>
                        <v-btn text @click="dialogUpdate = false">キャンセル</v-btn>
                    </v-card-actions>
                </v-card>
            </v-form>
        </v-dialog>
        <!-- dialogUpdate End -->

        <!-- dialogDelete Start -->
        <v-dialog v-model="dialogDelete" max-width="300" persistent>
            <v-form id="Delete" ref="Delete" @submit.prevent="Delete">
                <v-card>
                    <v-card-title> <span class="overline">delete</span> </v-card-title>
                        <v-card-text>
                            <v-container>
                                <v-row>
                                    <v-col cols="12">
                                        <span class="overline font-weight-black"> Delete Selected Items? </span>
                                    </v-col>
                                </v-row>
                            </v-container>
                        </v-card-text>
                    <v-card-actions>
                        <v-spacer></v-spacer>
                        <v-btn text type="submit">保存</v-btn>
                        <v-btn text @click="dialogDelete = false">キャンセル</v-btn>
                    </v-card-actions>
                </v-card>
            </v-form>
        </v-dialog>
        <!-- dialogDelete End -->

        <app-buttons  
            @toggleDialogDelete="toggleDialogDelete"
            @toggleDialogStore="toggleDialogStore" 
            :selectedData="selectedData"
            :floatButtons="floatButtons"
        > 
        </app-buttons>
        <app-footer :items="BOSS_CODE.length"></app-footer>
    </div>
</template>
<script>
import { mapState, mapActions } from 'vuex';
import ToolbarMenu from '../../modules/ToolbarMenu.vue';
import Footer from '../../modules/Footer.vue';
import FloatingButtons from '../../modules/FloatingButtons.vue';
    export default {
        components: {
            'app-toolbar': ToolbarMenu,
            'app-buttons': FloatingButtons,
            'app-footer': Footer
        },
        data: () => ({
            toolbar: {
                title: 'BOSS CODES',
                view: true,
                back: true,
                filter: false,
                master: false,
            },

            floatButtons:{
                add: true,
                update: true,
                delete: true
            },

            tempData: {},
            nb_bossCode : null,
            
            dialogStore: false,
            dialogUpdate: false,
            dialogDelete: false,
            column: null,
            boss_filter: '1',
            displayOPtion: [
                {
                    text: 'Yes',
                    value: 1
                },
                {
                    text: 'No',
                    value: 0
                },
            ],
            code_arrangement: 0,


        }),

        computed : {
            ...mapState([
                'BOSS_CODE',
                'boss_selection',
                'rules',
                'viewMode',
                'editMode'
            ]),

            dialogBossTitle(){
                return this.boss_filter == '1' ? 'Boss Code' : 'NB Boss Code'
            },

            selectedData(){
                // this will return only the id of the selected data
                return this.$store.state.BOSS_CODE.filter(res => res.selected).map(res => res.id); 
            }
        },

        methods: {
            ...mapActions([
                '_getBossCodes'
            ]),
            filterBossCodes(){
                this.$store.state.boss_selection = this.boss_filter;
                this._getBossCodes()
            },

            uppercaseInput(){
                this.nb_bossCode = this.nb_bossCode.toUpperCase();
            },

            toggleDialogDelete(val){
                console.log(val)
                this.dialogDelete = val;
            },

            Delete(){
                axios({
                    method: 'POST',
                    url: '/api/bossCode/delete',
                    data: {ids : this.selectedData}
                }).then(() => {
                    this._getBossCodes();
                    this.dialogDelete = false;
                })
            },

            toggleUpdateDialog(item){
                console.log(item)
                if(item){
                    this.tempData = {...item};
                    this.dialogUpdate = true;
                }else{
                    this.dialogUpdate = false;
                }
            },

            Update(){
                if(this.$refs.Update.validate()){
                    const myForm = document.getElementById('Update');
                    const formdata = new FormData(myForm);
                    const id = this.tempData.id

                    axios({
                        method: 'POST',
                        url: `/api/bossCode/update/${id}`,
                        data: formdata
                    }).then(() => {
                        this._getBossCodes();
                        this.dialogUpdate = false;
                    })
                }
            },

            Store(){
                if(this.$refs.Store.validate()){
                    const myForm = document.getElementById('Store');
                    const formdata = new FormData(myForm);

                    axios({
                        method: 'POST',
                        url: '/api/bossCode/store',
                        data: formdata
                    }).then(() => {
                        this._getBossCodes();
                        this.dialogStore = false;
                    })
                }
            },

            formatDate(val){
                return new Date(val).toLocaleString('en-US', { timeZone: 'Asia/Manila', hour12: false })
            },

            toggleDialogDelete(val){
                this.dialogDelete = val;
            },

            toggleDialogStore(val){
                if(this.boss_filter == '1'){
                    if(this.BOSS_CODE.length > 0){
                        this.code_arrangement = this.BOSS_CODE[this.BOSS_CODE.length - 1].code_arrangement + 1;
                    } else {
                        // ETO YUNG DEFAULT VALUE NYA PAG UNA PALANG PARA HINDI MAG UNDEFINED
                        this.code_arrangement = 1;
                    }
                    this.dialogStore = val;
                } else {
                    if(this.BOSS_CODE.length > 0){
                        this.code_arrangement = this.BOSS_CODE[this.BOSS_CODE.length - 1].code_arrangement + 1;
                    } else {
                        // ETO YUNG DEFAULT VALUE NYA PAG UNA PALANG PARA HINDI MAG UNDEFINED
                        this.code_arrangement = 1;
                    }
                    this.dialogStore = val;
                }
            },


        },

        mounted() {
            this.$store.state.boss_selection = this.boss_filter;
            this._getBossCodes();
            // this.filterBoss();
        },

        watch:{
            
        }
    }
</script>

<style scoped>


</style>